import app from 'flarum/forum/app';

/** My Community state: the member's places arrive with the page (app.data.vouchaCommunity). */
export const ROUTE = 'voucha-community.page';
export const MEMBERS_ROUTE = 'voucha-community.members';
export const GOVERNORS_ROUTE = 'voucha-community.governors';
export const KINGDOMS_ROUTE = 'voucha-community.kingdoms';
export function data() {
  return app.data && app.data.vouchaCommunity || {
    state: app.session && app.session.user ? 'setup' : 'guest',
    places: []
  };
}
export function setData(next) {
  app.data.vouchaCommunity = next;
}
function routeIs(name, path) {
  try {
    if (app.current && app.current.get('routeName')) return app.current.get('routeName') === name;
    return (m.route.get() || '').split('?')[0] === path;
  } catch (e) {
    return false;
  }
}

/** My Community's main page */
export function onCommunity() {
  return routeIs(ROUTE, '/community');
}

/** The governors view (public) */
export function onGovernors() {
  return routeIs(GOVERNORS_ROUTE, '/community/governors');
}

/** The traditional kingdoms page (grouped by state) */
export function onKingdoms() {
  return routeIs(KINGDOMS_ROUTE, '/community/kingdoms');
}

/** The members page (also an index page, with the same sidebars) */
export function onMembers() {
  return routeIs(MEMBERS_ROUTE, '/community/members');
}
export function param(name) {
  try {
    return m.route.param(name);
  } catch (e) {
    return undefined;
  }
}
export function activePlace() {
  const key = param('place');
  return data().places.find(p => p.key === key) || null;
}

/** Tags for the feed: the chosen place's, or all places' together. */
export function feedTags() {
  const place = activePlace();
  const list = place ? place.tags : data().places.flatMap(p => p.tags);
  return Array.from(new Set(list));
}

/** Editing your community: ?edit=1 (places) or ?edit=profession (straight to the profession questions) */
export function isEditing() {
  const v = param('edit');
  return v === '1' || v === 'profession';
}

/** Flag emoji for a country code (a small, dependency-free way to show flags in lists). */
export function flag(code) {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(...code.toUpperCase().split('').map(c => 0x1f1e6 + c.charCodeAt(0) - 65));
}

/**
 * Colour tier for a rank: #1 gold, #2 silver, #3 bronze, the bottom three muted red. Based on rank
 * alone, so it follows the leaderboard as it changes (governors and kingdoms use the same tiers).
 */
export function rankTier(rank, of) {
  if (!rank) return '';
  if (rank === 1) return ' is-gold';
  if (rank === 2) return ' is-silver';
  if (rank === 3) return ' is-bronze';
  if (of && of > 6 && rank > of - 3) return ' is-low';
  return '';
}
flarum.reg.add('voucha-community', 'common/community', { ROUTE: ROUTE,MEMBERS_ROUTE: MEMBERS_ROUTE,GOVERNORS_ROUTE: GOVERNORS_ROUTE,KINGDOMS_ROUTE: KINGDOMS_ROUTE,data: data,setData: setData,onCommunity: onCommunity,onGovernors: onGovernors,onKingdoms: onKingdoms,onMembers: onMembers,param: param,activePlace: activePlace,feedTags: feedTags,isEditing: isEditing,flag: flag,rankTier: rankTier, });